/**
 * Brunei dollar.
 */
export var BND = {
  code: 'BND',
  base: 10,
  exponent: 2
};